import { render, staticRenderFns } from "./CompetitionOffersCount.vue?vue&type=template&id=0cc2b9ef&scoped=true&"
import script from "./CompetitionOffersCount.vue?vue&type=script&lang=js&"
export * from "./CompetitionOffersCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2b9ef",
  null
  
)

export default component.exports